<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content md:tw-mx-0 tw-mx-5">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <div class="row">
        <section class="tw-w-full tw-mb-3">
          <fieldset class="tw-h-full">
            <legend>
              {{ pageVocabs + "legends.voiceInformation" | translate }}
            </legend>

            <div class="lg:tw-mx-7 tw-mx-3 tw-mt-4">
              <div
                class="alert alert-slate border-secondary tw-flex flex-column tw-w-full tw-mx-1"
                [innerHTML]="
                  pageVocabs + 'messages.generalExplanation' | translate
                "
              ></div>

              <div class="xl:tw-flex">
                <!-- name -->
                <div class="xl:tw-w-1/2 tw-w-full tw-mx-1">
                  <form-field
                    [(value)]="model.Name"
                    [control]="form?.get('name')"
                    [label]="'common.title'"
                  >
                  </form-field>
                </div>

                <!-- sendingMethod -->
                <div class="xl:tw-w-1/2 tw-w-full tw-mx-1">
                  <custom-select-search
                    [label]="fields + 'sendingMethod'"
                    [items]="
                      $any([
                        {
                          value: 'uploadFile',
                          name:
                            pageVocabs + 'legends.uploadVoiceFile' | translate
                        },
                        {
                          value: 'voiceReader',
                          name: pageVocabs + 'legends.voiceReader' | translate
                        }
                      ])
                    "
                    [control]="form?.get('sendingMethod')"
                    optionTitle="name"
                    optionValue="value"
                    [removable]="false"
                    [(value)]="sendingMethod"
                    (valueChange)="onChangeSendingMethod($event)"
                  >
                  </custom-select-search>
                </div>
              </div>
            </div>
          </fieldset>
        </section>

        <section class="tw-w-full" *ngIf="sendingMethod == 'uploadFile'">
          <fieldset class="tw-h-full">
            <legend>
              {{ pageVocabs + "legends.uploadVoiceFile" | translate }}
            </legend>

            <div class="lg:tw-mx-7 tw-mx-3 tw-mt-4">
              <div
                class="alert alert-primary border border-blue tw-flex flex-column"
                [innerHTML]="pageVocabs + 'messages.fileUploadGuid' | translate"
              ></div>

              <!-- upload file -->
              <file-uploader
                [label]="fields + 'voiceFile'"
                [control]="form?.get('file')"
                (valueChange)="getUploadedFile($event)"
                acceptFile=".mp3,.wav"
                [maxFileSize]="5"
                sizeType="mb"
                (onErrorFile)="showErrorDialog($event)"
              >
              </file-uploader>

              <!-- audio -->
              <app-audio-controller
                [audioSrc]="voiceFileSrc"
              ></app-audio-controller>
            </div>
          </fieldset>
        </section>

        <section class="tw-w-full" *ngIf="sendingMethod == 'voiceReader'">
          <fieldset class="tw-h-full">
            <legend>
              {{ pageVocabs + "legends.voiceReader" | translate }}
            </legend>

            <div class="lg:tw-mx-7 tw-mx-3 tw-mt-4">
              <div
                class="alert alert-primary border border-blue tw-flex flex-column"
                [innerHTML]="
                  pageVocabs + 'messages.textToVoiceGuid' | translate
                "
              ></div>

              <app-text-to-voice-convertor
                [agentVoiceMessageId]="model.AgentVoiceMessageId"
                [formId]="textToAudioFormId"
                (agentVoiceMessageId)="model.AgentVoiceMessageId = $event"
                (filePatch)="textToAudioConverterSoundPath = $event"
                (form)="textToAudioForm = $event"
              >
              </app-text-to-voice-convertor>
            </div>
          </fieldset>
        </section>
      </div>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
